<div class="custom-paginator-outer-container">
    <div class="custom-paginator-container">
        <div class="custom-paginator-range-actions">
            <fui-button
                title="{{appService.language_dictionary.system_previous_page_label}}"
                icon="chevron-left"
                height="slim"
                type="button-icon"
                borderRadius="circle"
                color="flat"
                [disabled]="_previousButtonsDisabled()"
                (clickEvent)="previousPage()">
            </fui-button>
            <mat-form-field class="custom-paginator-input-page" appearance="outline">
                <input #inputPageIndex matInput [value]="pageIndex + ''"
                       app-restrict-input="page-number"
                       (keyup.enter)="enterPageIndex(inputPageIndex.value, true)">
            </mat-form-field>
            <div class="custom-paginator-input-range-label">
                {{appService.language_dictionary.system_of}}
                <span>{{getNumberOfPages() == 0 ? 1 : getNumberOfPages()}}</span>
            </div>
            <fui-button
                title="{{appService.language_dictionary.system_next_page_label}}"
                icon="chevron-right"
                height="slim"
                type="button-icon"
                borderRadius="circle"
                color="flat"
                [disabled]="_nextButtonsDisabled()"
                (clickEvent)="nextPage()">
            </fui-button>
        </div>
        <div class="custom-paginator-page-size">
            <div class="custom-paginator-page-size-label">
                {{appService.language_dictionary.system_items_per_page_label}}
            </div>
            <mat-form-field
                *ngIf="_displayedPageSizeOptions.length > 1"
                [color]="color" appearance="outline"
                class="custom-paginator-page-size-select">
                <mat-select #matSelect
                    [panelClass]="selectBottom ? 'mat-select-search-panel-bottom' : ''"
                    [value]="pageSize"
                    [disabled]="disabled"
                    [aria-label]="appService.language_dictionary.system_items_per_page_label"
                    (selectionChange)="_changePageSize($event.value)">
                    <mat-option *ngFor="let pageSizeOption of _displayedPageSizeOptions" [value]="pageSizeOption">
                        {{pageSizeOption}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div *ngIf="_displayedPageSizeOptions.length <= 1">{{pageSize}}</div>
        </div>
        <div class="custom-paginator-range-actions">
            <div class="custom-paginator-range-label">
                {{getRangeLabel(pageIndex, pageSize, length)}}
            </div>
        </div>
    </div>
</div>
